
<div class="row">
    <mat-form-field class="col-sm-12">
              <mat-icon matSuffix>search</mat-icon>
        <input class="col-sm-12" [(ngModel)]="autocompleteInput" #addresstext type="text" placeholder="{{ 'SEARCH.ADRESSE' | translate }}"
          aria-label="Number" matInput required>
      </mat-form-field>      
</div>
